import { takeLatest, put, call } from 'redux-saga/effects';
import { FETCH_ERRORS, CLEAR_ERRORS } from '../error/types';
import { STATUS } from '../../config/constants/states';
import {
  GET_COUPON_LIST,
  SET_COUPON_LIST,
  COUPON_LIST_LOADED,
  CREATE_COUPON,
  COUPON_IS_CREATED,
  EDIT_COUPON,
  REMOVE_COUPON,
  COUPON_IS_EDITED,
  COUPON_IS_DELETED,
  VALIDATE_COUPON,
  CONSUME_COUPON,
  COUPON_IS_VALID,
  COUPON_IS_CONSUMED,
  COUPON_DISCOUNT
} from './types';
import {
  getCoupons,
  createNewCoupon,
  edit,
  remove,
  validate,
  consume
} from '../../network/coupon/index';

function* getCouponsList(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    const { data } = yield call(getCoupons, payload);
    yield put({ type: SET_COUPON_LIST, payload: data.payload });
    yield put({ type: COUPON_LIST_LOADED, payload: true });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: COUPON_LIST_LOADED, payload: false });
    const { status, data } = e.response;
    yield put({
      type: FETCH_ERRORS, payload: {
        status: status || 500,
        message: data.message || 'Internal server error',
      }
    });
  }
};


function* createCoupon(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    yield call(createNewCoupon, payload.params);
    yield put({ type: COUPON_IS_CREATED, payload: STATUS.SUCCESS });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: COUPON_IS_CREATED, payload: STATUS.ERROR });
    const { status, data } = e.response;
    yield put({
      type: FETCH_ERRORS, payload: {
        status: status || 500,
        message: data.message || 'Internal server error',
      }
    });
  }
};

function* editCoupon(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    yield call(edit, payload);
    yield put({ type: COUPON_IS_EDITED, payload: STATUS.SUCCESS });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: COUPON_IS_EDITED, payload: STATUS.ERROR });
    const { status, data } = e.response;
    yield put({
      type: FETCH_ERRORS, payload: {
        status: status || 500,
        message: data.message || 'Internal server error',
      }
    });
  }
};

function* removeCoupon(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    yield call(remove, payload);
    yield put({ type: COUPON_IS_DELETED, payload: STATUS.SUCCESS });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: COUPON_IS_DELETED, payload: STATUS.ERROR });
    const { status, data } = e.response;
    yield put({
      type: FETCH_ERRORS, payload: {
        status: status || 500,
        message: data.message || 'Internal server error',
      }
    });
  }
};

function* validateCoupon(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    const { data } = yield call(validate, payload);
    yield put({ type: COUPON_DISCOUNT, payload: data.payload });
    yield put({ type: COUPON_IS_VALID, payload: STATUS.SUCCESS });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: COUPON_IS_VALID, payload: STATUS.ERROR });
    const { status, data } = e.response;
    yield put({
      type: FETCH_ERRORS, payload: {
        status: status || 500,
        message: data.message || 'Internal server error',
      }
    });
  }
};

function* consumeCoupon(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    yield call(consume, payload);
    yield put({ type: COUPON_IS_CONSUMED, payload: STATUS.SUCCESS });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: COUPON_IS_CONSUMED, payload: STATUS.ERROR });
    const { status, data } = e.response;
    yield put({
      type: FETCH_ERRORS, payload: {
        status: status || 500,
        message: data.message || 'Internal server error',
      }
    });
  }
};

function* watchGetCouponList() {
  yield takeLatest(GET_COUPON_LIST, getCouponsList);
}

function* watchCreateCoupon() {
  yield takeLatest(CREATE_COUPON, createCoupon);
}

function* watchEditCoupon() {
  yield takeLatest(EDIT_COUPON, editCoupon);
}

function* watchRemoveCoupon() {
  yield takeLatest(REMOVE_COUPON, removeCoupon);
}

function* watchValidateCoupon() {
  yield takeLatest(VALIDATE_COUPON, validateCoupon);
}

function* watchConsumeCoupon() {
  yield takeLatest(CONSUME_COUPON, consumeCoupon);
}

export default [
  watchGetCouponList(),
  watchCreateCoupon(),
  watchEditCoupon(),
  watchRemoveCoupon(),
  watchValidateCoupon(),
  watchConsumeCoupon(),
];